import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { FiChevronDown } from 'react-icons/fi';
import { EASE_OUT } from '@/components/ui/motion';

interface SystemRowSummaryProps {
	rowLabel: string;
	notesSummary: string;
	hasNotes: boolean;
	isExpanded?: boolean;
}

const SystemRowSummary = (props: SystemRowSummaryProps) => {
	const { rowLabel, notesSummary, hasNotes, isExpanded = false } = props;

	return (
		<Flex align="center" justify="space-between" gap={3} minH="40px">
			<Box minW={0}>
				<Text textStyle="body.strong">{rowLabel}</Text>
				<Text textStyle="body.sm" color={hasNotes ? 'fg.muted' : 'fg.subtle'} truncate>
					{notesSummary}
				</Text>
			</Box>
			<Flex w="32px" h="32px" align="center" justify="center" flexShrink={0}>
				<Icon
					as={FiChevronDown}
					boxSize={4}
					color="fg.muted"
					transform={isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}
					transition={`transform 200ms ${EASE_OUT}`}
				/>
			</Flex>
		</Flex>
	);
};

export default SystemRowSummary;
